import React, { useState, useEffect } from 'react';
import ComboBoxSelect from './ComboBoxSelect';

const CBS_AreasOfExpertise = ({
  criteria,
  onCriteriaChange,
  label = "Select or add areas of expertise for this evaluation",
  placeholder = "Type to add custom areas of expertise...",
  showWarning = false
}) => {

  // Extract areas of expertise from criteria
  const getInitialAreasOfExpertise = () => {
    if (criteria?.areasOfExpertise?.items) {
      return criteria.areasOfExpertise.items.map((item) => ({
        value: item.expertise.toLowerCase().replace(/\s+/g, '-').replace(/[()]/g, ''),
        label: item.expertise,
        color: '#3b82f6'
      }));
    }
    return [];
  };

  // State for selected areas of expertise
  const [selectedAreas, setSelectedAreas] = useState(getInitialAreasOfExpertise());

  // Update selected areas when criteria changes
  useEffect(() => {
    setSelectedAreas(getInitialAreasOfExpertise());
  }, [criteria]);

  // Update areas of expertise criteria JSON
  const updateAreasOfExpertiseCriteria = (newSelectedAreas) => {
    if (!criteria) return;

    // Create updated criteria with new areas of expertise
    const updatedCriteria = {
      ...criteria,
      areasOfExpertise: {
        ...criteria.areasOfExpertise,
        items: newSelectedAreas.map(area => {
          // Check if this area already exists in our current criteria
          const existingArea = criteria.areasOfExpertise?.items?.find(
            item => item.expertise === area.label
          );
          
          if (existingArea) {
            // Keep existing area with all its properties
            return existingArea;
          } else {
            // Create new area entry with areasOfExpertise specific structure
            return {
              expertise: area.label,
              context: []
            };
          }
        })
      }
    };

    // Call parent callback with only the updated criteria
    onCriteriaChange(updatedCriteria);
  };

  // Handle area selection change
  const handleAreaChange = (newValue, actionMeta) => {
    const newSelectedAreas = newValue || [];
    setSelectedAreas(newSelectedAreas);
    updateAreasOfExpertiseCriteria(newSelectedAreas);
  };

  // Handle creating new area option
  const handleCreateOption = (inputValue) => {
    const newOption = {
      value: inputValue.toLowerCase().replace(/\s+/g, '-'),
      label: inputValue,
      color: '#3b82f6',
      __isNew__: true
    };
    const updatedAreas = [...selectedAreas, newOption];
    setSelectedAreas(updatedAreas);
    updateAreasOfExpertiseCriteria(updatedAreas);
  };

  return (
    <div className="mb-6">
      <ComboBoxSelect
        value={selectedAreas}
        onChange={handleAreaChange}
        options={[]} // No autocomplete options for areas of expertise - manual entry only
        placeholder={placeholder}
        label={label}
        onCreateOption={handleCreateOption}
      />
      {showWarning && (
        <div className="flex items-center justify-end gap-1 -mt-2 mb-2 text-xs text-red-600">
          <span>⚠️</span>
          <span>Over 10 items may reduce evaluation accuracy.</span>
        </div>
      )}
    </div>
  );
};

export default CBS_AreasOfExpertise;
